import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AuthService} from '../../services/api/auth.service';
import {User} from '../../models/user.interface';
import {environment} from '../../../environments/environment';
import {NavbarMenuItem, NavbarMenusConfig} from './navbar.menus.config';
import {Router} from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavbarComponent implements OnInit {
  @Input() currentUser: User;
  @Output() sidenavToggle: EventEmitter<void> = new EventEmitter();
  @Output() chooseOrganization: EventEmitter<number> = new EventEmitter<number>();
  public menusConfig: NavbarMenuItem[] = NavbarMenusConfig;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router
  ) {
  }

  public get pictureUrl(): string | undefined {
    if (this.currentUser.picture === null) {
      return;
    }

    const fileName: string = this.currentUser.picture;
    const storageUrl: string = environment.fileStorageUrl;
    return `${storageUrl}/users/${fileName}`;
  }

  public ngOnInit(): void {
    this.setLogoutHandler();
  }

  public onChangeOrganization(organizationId: number) {
    this.chooseOrganization.emit(organizationId);
  }

  public onMenuClick(menu: NavbarMenuItem): void {
    if (menu.path) {
      this.router.navigate([menu.path])
        .catch((error: unknown): void => console.error(`Navigate to ${menu.path} error:`, error));
      return;
    }

    if (menu.handler) {
      menu.handler();
      return;
    }
  }

  public isShowMenuItem(menuItem: NavbarMenuItem): boolean {
    const roleId: number = this.currentUser.role.value;
    const accessRoleIds: number[] = menuItem.access;
    return accessRoleIds.includes(roleId);
  }

  private setLogoutHandler(): void {
    const logoutItem: NavbarMenuItem = this.menusConfig
      .find((menu: NavbarMenuItem): boolean => menu.code === 'logout');
    if (logoutItem) {
      logoutItem.handler = (): void => this.authService.logout();
    }
  }
}
